import {
  formattedPropertyModel,
  RenderingServices,
  utils,
} from '@wallaby-ui/core';
import {isNil, isString} from 'lodash';

export default function baseTextFormatterParams(
  params,
  services: RenderingServices = {}
) {
  const {value} = params;
  const {intl} = services;
  let formattedValue;
  let label;
  let valueStyle;
  let parsedValue = null;
  if (!isNil(value)) {
    if (value.value) {
      parsedValue = JSON.parse(value.value);
    } else if (isString(value)) {
      parsedValue = JSON.parse(value);
    }
  }
  const hasValue = parsedValue && !isNil(parsedValue.value);

  if (hasValue) {
    const format =
      parsedValue.format || formattedPropertyModel.FORMATTED_PROPERTY_TYPE_TEXT;
    const propDefinition = new formattedPropertyModel.FormattedProperty({
      type: format,
    });
    formattedValue = formattedPropertyModel.FormattedProperty.formatValue(
      propDefinition,
      parsedValue.value,
      intl
    );
    label =
      parsedValue.tooltip && intl
        ? utils.TranslateUtils.translate(parsedValue.tooltip, intl)
        : undefined;
    valueStyle = parsedValue.style ? parsedValue.style : '';
  }

  return {...params, formattedValue, hasValue, label, valueStyle};
}
